// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mainNavigationStyles } from "@tps/Overrides/Widgets/Header/MainNavigation";
import IconHeaderUtilityDropdownDown from "@tps/XDL/Icons/IconHeaderUtilityDropdownDown";
import { color, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

mainNavigationStyles.container = {
    css: css`
        color: ${color("common.background")};
        display: flex;
        justify-content: left;
    `,
};
mainNavigationStyles.itemWrapper = {
    css: css`
        position: relative;
        overflow: visible;
        display: flex;
        justify-content: flex-start;
        gap: 64px;
        padding-left: 0;
        padding-right: 0;

        ${xScreen("lt", 1300)} {
            gap: 32px;
        }
    `,
};
mainNavigationStyles.menuItem = {
    css: css`
         height: 22px;
        &.active {
            &,
            ${TypographyStyle}, ${IconWrapper} {
                color: ${color("common.ui8")};
            }
            ${IconWrapper} {
                transform: rotate(180deg);
            }
        }
    `,
};
mainNavigationStyles.menuItemIcon = {
    size: 9,
    color: "common.ui4",
    src: IconHeaderUtilityDropdownDown,
    css: css`
        margin-left: 8px;
    `,
};
mainNavigationStyles.menuItemTypography = {
    size: 14,
    weight: "bold",
    color: "text.main",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        display: flex;
        align-items: baseline;
        white-space: nowrap;
    `,
};

mainNavigationStyles.mobileMenuWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: flex-end;
    `,
};